// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/DynamicFacet/_DynamicFacet.scss
// module id = 223
// module chunks = 2 4 8 88